import { createTheme, Input, type MantineColorsTuple, Combobox, Popover, Select, Autocomplete, Loader } from "@mantine/core"
import { RingLoader } from "@/components/RingLoader"

const colors: MantineColorsTuple = [
  "#ffebee",
  "#fbd8da",
  "#edafb3",
  "#e0848b",
  "#d56068",
  "#cf4851",
  "#cc3c46",
  "#b52e37",
  "#a22530",
  "#8f1a27"
]

// Orange color palette for Free Fire theme
const orangeColors: MantineColorsTuple = [
  "#fff4e6",
  "#ffe8cc",
  "#ffd8a8",
  "#ffc078",
  "#ffa94d",
  "#ff922b",
  "#ff5722",
  "#e8590c",
  "#d9480f",
  "#c92a2a"
]

export const theme = createTheme({
  fontFamily: 'GFF Latin',
  primaryColor: 'ff-orange',
  defaultRadius: 'md',
  colors: {
    'garena-red': colors,
    'ff-orange': orangeColors,
  },
  components: {
    Loader: Loader.extend({
      defaultProps: {
        loaders: { ...Loader.defaultLoaders, ring: RingLoader },
        type: 'ring',
      },
    }),
    Input: Input.extend({
      defaultProps: {
        variant: 'filled',
      },
    }),
    Select: Select.extend({
      defaultProps: {
        comboboxProps: {
          transitionProps: {
            transition: 'fade',
          },
        },
      },
    }),
    Autocomplete: Autocomplete.extend({
      defaultProps: {
        comboboxProps: {
          transitionProps: {
            transition: 'fade',
          },
        },
      },
    }),
    Popover: Popover.extend({
      defaultProps: {
        transitionProps: {
          transition: 'fade',
        },
      },
    }),
    
    Combobox: Combobox.extend({
      defaultProps: {
        transitionProps: {
          transition: 'fade',
        },
      },
    }),
  },
})